import React, { useState, useEffect, useRef } from 'react';
import LoadingAnimation from './LoadingAnimation';
import LanguageGreeting from './LanguageGreeting';

const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    // Reset states on page refresh
    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.removeItem('loadingShown');
            sessionStorage.removeItem('isAuthenticated');
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);

    // Check for existing authentication
    useEffect(() => {
        const authenticated = sessionStorage.getItem('isAuthenticated');
        if (authenticated === 'true') {
            setIsAuthenticated(true);
        }
        setIsLoading(true);
        sessionStorage.removeItem('loadingShown');
    }, []);

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (password === 'Push201199') {
            setIsAuthenticated(true);
            sessionStorage.setItem('isAuthenticated', 'true');
            setError('');
        } else {
            setError('Incorrect password');
            setPassword('');
        }
    };

    const PasswordForm = () => {
        const inputRef = useRef(null);

        // Focus input on component mount and after incorrect password
        useEffect(() => {
            inputRef.current?.focus();
        }, [error]); // Re-focus when error changes (incorrect password attempt)

        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-900">
                <div className="p-8 bg-gray-800 rounded-lg shadow-xl">
                    <form onSubmit={handlePasswordSubmit} className="space-y-4">
                        <h2 className="text-2xl font-bold text-white mb-6">Enter Password</h2>
                        <div>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full p-2 bg-gray-700 text-white rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
                                placeholder="Enter password"
                                ref={inputRef}
                            />
                        </div>
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                        <button
                            type="submit"
                            className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded transition duration-200"
                        >
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        )
    };

    if (!isAuthenticated) {
        return <PasswordForm />;
    }

    return (
        <div className="min-h-screen bg-gray-900">
            {isLoading && <LoadingAnimation onLoadingComplete={() => setIsLoading(false)} />}
            {!isLoading && <LanguageGreeting />}
        </div>
    );
};

export default App;